import { render } from "./WorkMusic.vue?vue&type=template&id=2c0bea8b&scoped=true"
import script from "./WorkMusic.vue?vue&type=script&lang=js"
export * from "./WorkMusic.vue?vue&type=script&lang=js"

import "./WorkMusic.vue?vue&type=style&index=0&id=2c0bea8b&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0bea8b"]])

export default __exports__